import { render, staticRenderFns } from "./CourseImage.vue?vue&type=template&id=3b79c01e&"
import script from "./CourseImage.vue?vue&type=script&lang=js&"
export * from "./CourseImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports